import {
  sidebarPanelContentAtom,
  sidebarPanelPinnedAtom,
  type SidebarPanelContent,
  type SidebarPanelPinnedContent,
} from '@/atoms/sidebarPanelAtoms';
import { useAtomValue } from 'jotai';
import { useSelectedSidebarContent } from './use-selected-sidebar-content';

interface VisibleSidebarPanelContentOptions {
  hoverContent: SidebarPanelContent;
  isPinned: boolean;
  selectedContent: SidebarPanelPinnedContent | null;
}

export function getVisibleSidebarPanelContent({
  hoverContent,
  isPinned,
  selectedContent,
}: VisibleSidebarPanelContentOptions): SidebarPanelContent {
  return hoverContent ?? (isPinned ? selectedContent : null);
}

export function useVisibleSidebarPanelContent(): SidebarPanelContent {
  const hoverContent = useAtomValue(sidebarPanelContentAtom);
  const isPinned = useAtomValue(sidebarPanelPinnedAtom);
  const selectedContent = useSelectedSidebarContent();

  return getVisibleSidebarPanelContent({
    hoverContent,
    isPinned,
    selectedContent,
  });
}
